import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=4986d9d4&scoped=true"
import script from "./saleDetail.vue?vue&type=script&lang=js"
export * from "./saleDetail.vue?vue&type=script&lang=js"
import style0 from "./saleDetail.vue?vue&type=style&index=0&id=4986d9d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986d9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4986d9d4')) {
      api.createRecord('4986d9d4', component.options)
    } else {
      api.reload('4986d9d4', component.options)
    }
    module.hot.accept("./saleDetail.vue?vue&type=template&id=4986d9d4&scoped=true", function () {
      api.rerender('4986d9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/saleDetail.vue"
export default component.exports